var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.title,"show-close-button":true,"show-submit-button":false,"cancel-text":"Close","close-on-outside-click":true,"disable-submit-button":_vm.isSubscriptionReadOnly()},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }